import InspectionWizard from "./InspectionWizard";
import { labelCategorie } from "./VehiculesListe";
import { formaterDate } from "../format";
import {
  VERDICTS, decoderConclusion, encoderConclusion, nettoyerEntier, estVide,
  OPT_MARQUAGE, OPT_BON_DEFAUT, OPT_BON_DEFAUT_SO, libelleOption, afficheOuiNon,
  ChampLecture, LigneChoix, CaseOuiNon, CaseACocher,
} from "./champsInspection";

const ETAPES = [
  { num: 1, titre: "Nature & conclusion" },
  { num: 2, titre: "Identification véhicule" },
  { num: 3, titre: "Contrôleur" },
  { num: 4, titre: "Documents & propreté" },
  { num: 5, titre: "Examen préalable" },
  { num: 6, titre: "Éléments mécaniques" },
  { num: 7, titre: "Éléments hydrauliques" },
  { num: 8, titre: "Défauts, photos & récapitulatif" },
];

const CHAMPS_CT = [
  "livret_securite_present",
  "carnet_bord", "carnet_maintenance", "declaration_conformite", "declaration_montage", "marquage",
  "nettoye_pour_verif", "graissage", "obs_proprete",
  "vehicule_en_location", "charges_suffisantes", "zone_securite", "personnel_dispo", "moyens_manutention",
  "meca_etat_general", "meca_fixation", "meca_bagues_axes", "meca_plateau", "meca_rouleaux",
  "meca_capot", "meca_cables", "obs_meca",
  "hydro_niveau_huile", "hydro_absence_fuite", "hydro_valves", "hydro_distributeurs", "hydro_groupe",
  "hydro_verins", "hydro_flexibles", "obs_hydro",
];
// Le livret de securite dispose desormais de sa propre colonne dans ct_details.
const BLOCS = [{ cle: "ct_details", champs: CHAMPS_CT }];

function valider(numero, form) {
  if (!form) return [];
  const e = [];
  if (numero === 1) {
    if (estVide(form.conclusion)) e.push("La conclusion est requise.");
  } else if (numero === 2) {
    if (estVide(form.kilometrage_releve)) e.push("Le kilométrage relevé est requis.");
  } else if (numero === 3) {
    if (!String(form.controleur_nom ?? "").trim()) e.push("Le nom du contrôleur est requis.");
    if (!String(form.controleur_entreprise ?? "").trim()) {
      e.push("L'entreprise du contrôleur est requise.");
    }
  }
  return e;
}

const MECA = [
  ["meca_etat_general", "État général"],
  ["meca_fixation", "Fixation"],
  ["meca_bagues_axes", "Bagues & axes"],
  ["meca_plateau", "Plateau"],
  ["meca_rouleaux", "Rouleaux"],
  ["meca_capot", "Capot"],
];
const HYDRO_CHECK = [
  ["hydro_valves", "Valves"],
  ["hydro_distributeurs", "Distributeurs"],
  ["hydro_groupe", "Groupe"],
  ["hydro_verins", "Vérins"],
  ["hydro_flexibles", "Flexibles"],
];

function renderEtape(etape, ctx) {
  const {
    form, ro, vehicule, majTronc, majDetails, modifiable,
    defauts, ajouterDefaut, majDefautLocal, sauverDefaut, supprimerDefaut,
    photos, apercus, onUploadPhotos, majLegendeLocale, sauverLegende, supprimerPhoto,
  } = ctx;
  const d = form.details;
  const majConclusion = (verdict, commentaire) =>
    majTronc("conclusion", encoderConclusion(verdict, commentaire));

  if (etape === 1) {
    const { verdict, commentaire } = decoderConclusion(form.conclusion);
    return (
      <>
        <div className="grille-form">
          <label>
            Nature du contrôle
            <input value="Contrôle technique" readOnly disabled />
          </label>
          <label>
            N° de contrôle
            <input value={form.numero_controle} disabled={ro}
              onChange={(e) => majTronc("numero_controle", e.target.value)} />
          </label>
          <div className="champ-verrouille-wrapper">
            <span className="champ-verrouille-label">Date du contrôle</span>
            <div className="champ-verrouille-valeur">
              {form.date_controle ? formaterDate(form.date_controle) : "—"}
              <span className="champ-verrouille-mention">fixée automatiquement à la création</span>
            </div>
          </div>
          <label>
            Heure du contrôle
            <input type="time" value={(form.heure_controle || "").slice(0, 5)} disabled={ro}
              onChange={(e) => majTronc("heure_controle", e.target.value)} />
          </label>
          <label>
            Validité (mois)
            <input inputMode="numeric" value={form.validite_mois} disabled={ro}
              onChange={(e) => majTronc("validite_mois", nettoyerEntier(e.target.value))} />
          </label>
        </div>
        <fieldset className="groupe-radio">
          <legend>Conclusion *</legend>
          {VERDICTS.map((v) => (
            <label key={v} className="option-radio">
              <input type="radio" name="verdict" checked={verdict === v} disabled={ro}
                onChange={() => majConclusion(v, commentaire)} />
              {v}
            </label>
          ))}
        </fieldset>
        <label className="champ-large">
          Commentaire complémentaire (optionnel)
          <textarea rows={3} value={commentaire} disabled={ro}
            onChange={(e) => majConclusion(verdict, e.target.value)} />
        </label>
      </>
    );
  }

  if (etape === 2) {
    return (
      <>
        <div className="grille-champs">
          <ChampLecture label="Immatriculation" valeur={vehicule?.immatriculation} />
          <ChampLecture label="Marque" valeur={vehicule?.marque} />
          <ChampLecture label="N° châssis" valeur={vehicule?.n_chassis} />
          <ChampLecture label="Type / modèle" valeur={vehicule?.type_modele} />
          <ChampLecture label="Catégorie" valeur={vehicule ? labelCategorie(vehicule.categorie) : ""} />
        </div>
        <div className="grille-form bloc-saisie">
          <label>
            Kilométrage relevé au contrôle *
            <input inputMode="numeric" value={form.kilometrage_releve} disabled={ro}
              onChange={(e) => majTronc("kilometrage_releve", nettoyerEntier(e.target.value))} />
          </label>
        </div>
      </>
    );
  }

  if (etape === 3) {
    return (
      <>
        <div className="grille-form">
          <label>
            Nom *
            <input value={form.controleur_nom} disabled={ro}
              onChange={(e) => majTronc("controleur_nom", e.target.value)} />
          </label>
          <label>
            Prénom
            <input value={form.controleur_prenom} disabled={ro}
              onChange={(e) => majTronc("controleur_prenom", e.target.value)} />
          </label>
          <label>
            Entreprise *
            <input value={form.controleur_entreprise} disabled={ro}
              onChange={(e) => majTronc("controleur_entreprise", e.target.value)} />
          </label>
          <label>
            Cachet entreprise
            <input value={form.cachet_entreprise} disabled={ro}
              onChange={(e) => majTronc("cachet_entreprise", e.target.value)} />
          </label>
        </div>
        <div className="checklist">
          <CaseOuiNon label="Livret de sécurité présent" name="livret"
            valeur={d.livret_securite_present} ro={ro}
            onChange={(v) => majDetails("livret_securite_present", v)} />
        </div>
      </>
    );
  }

  if (etape === 4) {
    return (
      <div className="checklist">
        <CaseOuiNon label="Carnet de bord" name="carnet_bord" valeur={d.carnet_bord} ro={ro}
          onChange={(v) => majDetails("carnet_bord", v)} />
        <CaseOuiNon label="Carnet de maintenance" name="carnet_maintenance" valeur={d.carnet_maintenance}
          ro={ro} onChange={(v) => majDetails("carnet_maintenance", v)} />
        <CaseOuiNon label="Déclaration de conformité" name="declaration_conformite"
          valeur={d.declaration_conformite} ro={ro}
          onChange={(v) => majDetails("declaration_conformite", v)} />
        <CaseOuiNon label="Déclaration de montage" name="declaration_montage"
          valeur={d.declaration_montage} ro={ro}
          onChange={(v) => majDetails("declaration_montage", v)} />
        <LigneChoix label="Marquage" name="marquage" valeur={d.marquage} options={OPT_MARQUAGE}
          ro={ro} onChange={(v) => majDetails("marquage", v)} />
        <CaseOuiNon label="Nettoyé pour vérification" name="nettoye_pour_verif"
          valeur={d.nettoye_pour_verif} ro={ro}
          onChange={(v) => majDetails("nettoye_pour_verif", v)} />
        <LigneChoix label="Graissage" name="graissage" valeur={d.graissage} options={OPT_BON_DEFAUT}
          ro={ro} onChange={(v) => majDetails("graissage", v)} />
        <label className="champ-large">
          Observations propreté / lubrification
          <textarea rows={3} value={d.obs_proprete ?? ""} disabled={ro}
            onChange={(e) => majDetails("obs_proprete", e.target.value)} />
        </label>
      </div>
    );
  }

  if (etape === 5) {
    return (
      <div className="checklist">
        <CaseOuiNon label="Véhicule en location" name="vehicule_en_location"
          valeur={d.vehicule_en_location} ro={ro}
          onChange={(v) => majDetails("vehicule_en_location", v)} />
        <CaseOuiNon label="Charges suffisantes" name="charges_suffisantes"
          valeur={d.charges_suffisantes} ro={ro}
          onChange={(v) => majDetails("charges_suffisantes", v)} />
        <CaseOuiNon label="Zone de sécurité" name="zone_securite" valeur={d.zone_securite} ro={ro}
          onChange={(v) => majDetails("zone_securite", v)} />
        <CaseOuiNon label="Personnel disponible" name="personnel_dispo" valeur={d.personnel_dispo}
          ro={ro} onChange={(v) => majDetails("personnel_dispo", v)} />
        <CaseOuiNon label="Moyens de manutention" name="moyens_manutention"
          valeur={d.moyens_manutention} ro={ro}
          onChange={(v) => majDetails("moyens_manutention", v)} />
      </div>
    );
  }

  if (etape === 6) {
    return (
      <div className="checklist">
        {MECA.map(([champ, label]) => (
          <LigneChoix key={champ} label={label} name={champ} valeur={d[champ]} options={OPT_BON_DEFAUT}
            ro={ro} onChange={(v) => majDetails(champ, v)} />
        ))}
        <LigneChoix label="Câbles" name="meca_cables" valeur={d.meca_cables} options={OPT_BON_DEFAUT_SO}
          ro={ro} onChange={(v) => majDetails("meca_cables", v)} />
        <label className="champ-large">
          Observations éléments mécaniques
          <textarea rows={3} value={d.obs_meca ?? ""} disabled={ro}
            onChange={(e) => majDetails("obs_meca", e.target.value)} />
        </label>
      </div>
    );
  }

  if (etape === 7) {
    return (
      <div className="checklist">
        <LigneChoix label="Niveau d'huile" name="hydro_niveau_huile" valeur={d.hydro_niveau_huile}
          options={OPT_BON_DEFAUT} ro={ro} onChange={(v) => majDetails("hydro_niveau_huile", v)} />
        <LigneChoix label="Absence de fuite" name="hydro_absence_fuite" valeur={d.hydro_absence_fuite}
          options={OPT_BON_DEFAUT} ro={ro} onChange={(v) => majDetails("hydro_absence_fuite", v)} />
        {HYDRO_CHECK.map(([champ, label]) => (
          <CaseACocher key={champ} label={label} checked={d[champ]} ro={ro}
            onChange={(v) => majDetails(champ, v)} />
        ))}
        <label className="champ-large">
          Observations éléments hydrauliques
          <textarea rows={3} value={d.obs_hydro ?? ""} disabled={ro}
            onChange={(e) => majDetails("obs_hydro", e.target.value)} />
        </label>
      </div>
    );
  }

  if (etape === 8) {
    const { verdict, commentaire } = decoderConclusion(form.conclusion);
    const defautsTries = [...defauts].sort((a, b) => a.numero_ordre - b.numero_ordre);
    const bd = (v) => libelleOption(v, OPT_BON_DEFAUT_SO);
    return (
      <>
        <div className="recap-bloc">
          <h5>Défauts constatés</h5>
          {defautsTries.length === 0 ? (
            <p className="vide">Aucun défaut constaté.</p>
          ) : (
            <ol className="defauts-liste">
              {defautsTries.map((def, i) => (
                <li key={def.id} className="defaut-ligne">
                  <span className="defaut-num">{i + 1}/</span>
                  <input value={def.description ?? ""} disabled={ro} placeholder="Description du défaut"
                    onChange={(e) => majDefautLocal(def.id, e.target.value)}
                    onBlur={() => sauverDefaut(def)} />
                  {!ro && (
                    <button type="button" className="lien-action lien-danger"
                      onClick={() => supprimerDefaut(def)}>Supprimer</button>
                  )}
                </li>
              ))}
            </ol>
          )}
          {!ro && (
            <button type="button" className="btn" onClick={ajouterDefaut}>+ Ajouter un défaut</button>
          )}
        </div>

        <div className="recap-bloc">
          <h5>Photos</h5>
          {!ro && (
            <label className="zone-upload">
              <input type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={onUploadPhotos} />
              <span>+ Ajouter des photos (JPEG, PNG, WebP — 10 Mo max)</span>
            </label>
          )}
          {photos.length === 0 ? (
            <p className="vide">Aucune photo.</p>
          ) : (
            <div className="photos-grille">
              {photos.map((p) => (
                <div key={p.id} className="photo-carte">
                  {apercus[p.id] ? (
                    <img src={apercus[p.id]} alt={p.legende || "Photo d'inspection"} />
                  ) : (
                    <div className="photo-vide">Chargement…</div>
                  )}
                  <input className="photo-legende" value={p.legende ?? ""} disabled={ro}
                    placeholder="Légende (optionnel)"
                    onChange={(e) => majLegendeLocale(p.id, e.target.value)}
                    onBlur={() => sauverLegende(p)} />
                  {!ro && (
                    <button type="button" className="lien-action lien-danger"
                      onClick={() => supprimerPhoto(p)}>Supprimer</button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        <h4 className="recap-titre">Récapitulatif du contrôle technique</h4>
        <div className="recap-bloc">
          <h5>Nature &amp; conclusion</h5>
          <div className="grille-champs">
            <ChampLecture label="Nature" valeur="Contrôle technique" />
            <ChampLecture label="N° de contrôle" valeur={form.numero_controle} />
            <ChampLecture label="Date" valeur={form.date_controle ? formaterDate(form.date_controle) : ""} />
            <ChampLecture label="Heure" valeur={(form.heure_controle || "").slice(0, 5)} />
            <ChampLecture label="Validité (mois)" valeur={form.validite_mois} />
            <ChampLecture label="Conclusion" valeur={verdict} />
            <ChampLecture label="Commentaire" valeur={commentaire} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Identification véhicule</h5>
          <div className="grille-champs">
            <ChampLecture label="Immatriculation" valeur={vehicule?.immatriculation} />
            <ChampLecture label="Marque" valeur={vehicule?.marque} />
            <ChampLecture label="N° châssis" valeur={vehicule?.n_chassis} />
            <ChampLecture label="Type / modèle" valeur={vehicule?.type_modele} />
            <ChampLecture label="Catégorie" valeur={vehicule ? labelCategorie(vehicule.categorie) : ""} />
            <ChampLecture label="Kilométrage relevé" valeur={form.kilometrage_releve} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Contrôleur</h5>
          <div className="grille-champs">
            <ChampLecture label="Nom" valeur={form.controleur_nom} />
            <ChampLecture label="Prénom" valeur={form.controleur_prenom} />
            <ChampLecture label="Entreprise" valeur={form.controleur_entreprise} />
            <ChampLecture label="Cachet entreprise" valeur={form.cachet_entreprise} />
            <ChampLecture label="Livret de sécurité présent" valeur={afficheOuiNon(d.livret_securite_present)} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Documents &amp; propreté</h5>
          <div className="grille-champs">
            <ChampLecture label="Carnet de bord" valeur={afficheOuiNon(d.carnet_bord)} />
            <ChampLecture label="Carnet de maintenance" valeur={afficheOuiNon(d.carnet_maintenance)} />
            <ChampLecture label="Déclaration conformité" valeur={afficheOuiNon(d.declaration_conformite)} />
            <ChampLecture label="Déclaration montage" valeur={afficheOuiNon(d.declaration_montage)} />
            <ChampLecture label="Marquage" valeur={libelleOption(d.marquage, OPT_MARQUAGE)} />
            <ChampLecture label="Nettoyé pour vérif." valeur={afficheOuiNon(d.nettoye_pour_verif)} />
            <ChampLecture label="Graissage" valeur={libelleOption(d.graissage, OPT_BON_DEFAUT)} />
            <ChampLecture label="Observations" valeur={d.obs_proprete} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Examen préalable</h5>
          <div className="grille-champs">
            <ChampLecture label="Véhicule en location" valeur={afficheOuiNon(d.vehicule_en_location)} />
            <ChampLecture label="Charges suffisantes" valeur={afficheOuiNon(d.charges_suffisantes)} />
            <ChampLecture label="Zone de sécurité" valeur={afficheOuiNon(d.zone_securite)} />
            <ChampLecture label="Personnel disponible" valeur={afficheOuiNon(d.personnel_dispo)} />
            <ChampLecture label="Moyens de manutention" valeur={afficheOuiNon(d.moyens_manutention)} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Éléments mécaniques</h5>
          <div className="grille-champs">
            {MECA.map(([champ, label]) => (
              <ChampLecture key={champ} label={label} valeur={libelleOption(d[champ], OPT_BON_DEFAUT)} />
            ))}
            <ChampLecture label="Câbles" valeur={bd(d.meca_cables)} />
            <ChampLecture label="Observations" valeur={d.obs_meca} />
          </div>
        </div>
        <div className="recap-bloc">
          <h5>Éléments hydrauliques</h5>
          <div className="grille-champs">
            <ChampLecture label="Niveau d'huile" valeur={libelleOption(d.hydro_niveau_huile, OPT_BON_DEFAUT)} />
            <ChampLecture label="Absence de fuite" valeur={libelleOption(d.hydro_absence_fuite, OPT_BON_DEFAUT)} />
            {HYDRO_CHECK.map(([champ, label]) => (
              <ChampLecture key={champ} label={label} valeur={afficheOuiNon(d[champ])} />
            ))}
            <ChampLecture label="Observations" valeur={d.obs_hydro} />
          </div>
        </div>

        {modifiable && (
          <p className="note-info">
            Vérifiez le récapitulatif ci-dessus. Après finalisation, l'inspection passe en lecture
            seule (plus aucune modification possible).
          </p>
        )}
      </>
    );
  }

  return <p className="vide">Contenu de l'étape {etape} à venir.</p>;
}

export default function CtWizard({ user, onLogout }) {
  return (
    <InspectionWizard
      user={user}
      onLogout={onLogout}
      titre="Contrôle technique"
      blocsDetails={BLOCS}
      etapes={ETAPES}
      valider={valider}
      renderEtape={renderEtape}
    />
  );
}
